import { createImpressionEvent } from '../base';
import { NOTABLE_CLIENTS_ABOVE_FOLD_PARAMS, NOTABLE_CLIENTS_BELOW_FOLD_PARAMS } from '../constants';

export const createNotableClientAboveTheFoldComponentIsShown = (type) =>
    createImpressionEvent(type, NOTABLE_CLIENTS_ABOVE_FOLD_PARAMS);

export const createNotableClientBelowTheFoldComponentIsShown = (type) =>
    createImpressionEvent(type, NOTABLE_CLIENTS_BELOW_FOLD_PARAMS);
